module.exports = __webpack_public_path__ + "img/AT0000002680468.4dcaf403.png";